import React from 'react';
import './contentStyle.scss';
import Const from './../Const';
import { connect } from 'react-redux';
import {
  REDUCER_NAME,
  changeTimeZone,
  callApiSystemSetting,
  updateUserSetting,
} from './../../reducer';
import { DropDown } from '../../../../common/dropdown';
import SaveButton from './../footer-button-save/SaveButton';
import { Translate } from 'react-redux-i18n';
import { getUnique } from './../../../../helpers/Common';
import { listLanguage } from './../../../../../configs/LanguageConfig';
import { THEMES, FONTSIZE } from './../../../../../configs/LayoutConfig';
import { getFontSize } from './../../../../helpers/FontSize';
import { getLanguage } from './../../../../helpers/Language';
import { getTheme } from './../../../../helpers/Theme';

class GeneralContentSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      language: getLanguage(),
      theme: getTheme(),
      fontSize: getFontSize(),
    };
  }

  changeLanguage = language => {
    this.setState({ language });
  };

  changeTheme = theme => {
    this.setState({ theme });
  };

  changeFontSize = fontSize => {
    this.setState({ fontSize });
  };

  renderRowRadioButton = (title, list, current, action) => {
    return (
      <div className="row-content">
        <div className="wrap-row-general">
          <span className="title-span">
            <Translate value={title} />
          </span>
          {Object.keys(list).map((key, index) => {
            return (
              <div
                style={{ width: 90 }}
                className="radio-custom d-flex align-items-center"
                key={getUnique() + index}
                onClick={() => action(list[key])}
              >
                <input
                  className={`radio-button`}
                  type="radio"
                  value={list[key]}
                  checked={current === list[key]}
                  readOnly
                />
                <label className="ml-10">
                  <Translate
                    value={`systemSetting.radioButtonTitle.${list[key]}`}
                  />
                </label>
              </div>
            );
          })}
        </div>
        <div className="line-dotted" />
      </div>
    );
  };

  renderTimeZone = () => {
    const { timeZone, changeTimeZone, timeFormat } = this.props;

    return (
      <div className="row-content">
        <div className="wrap-row-general">
          <span className="title-span">
            <Translate value={`systemSetting.listTitleGeneral.timeZone`} />
          </span>
          <div className="line-drop">
            <DropDown
              keyTitle="value"
              listKey={Const.listTimeZone}
              listDataByKey={Const.listTimeZoneByKey}
              currentKey={timeZone}
              change={changeTimeZone}
              isEditable={false}
            />
          </div>
        </div>

        <div className="wrap-row-general">
          <span className="title-span">
            <Translate value={`systemSetting.listTitleGeneral.format`} />
          </span>
          <span>UK</span>
        </div>
        <div className="line-dotted" />
      </div>
    );
  };

  renderSample = () => {
    return (
      <div className="row-content">
        <div className="wrap-row-general mt-5">
          <span className="title-span">
            <Translate value={`systemSetting.listTitleGeneral.sample`} />
          </span>
        </div>

        <div className="wrap-row mt-5">
          <span className="title-span">
            <Translate value={`systemSetting.listTitleGeneral.date`} />
          </span>
          <span>11/23/2018</span>
        </div>

        <div className="wrap-row mt-5">
          <span className="title-span">
            <Translate value={`systemSetting.listTitleGeneral.time`} />
          </span>
          <span>11:15</span>
        </div>
      </div>
    );
  };

  renderSaveButton = () => {
    return <SaveButton data={this.state} />;
  };

  render() {
    const { language, theme, fontSize } = this.state;

    return (
      <div className="setting-system-popup">
        {this.renderRowRadioButton(
          'systemSetting.listTitleGeneral.language',
          listLanguage,
          language,
          this.changeLanguage,
        )}
        {this.renderRowRadioButton(
          'systemSetting.listTitleGeneral.theme',
          THEMES,
          theme,
          this.changeTheme,
        )}
        {this.renderRowRadioButton(
          'systemSetting.listTitleGeneral.textSize',
          FONTSIZE,
          fontSize,
          this.changeFontSize,
        )}
        {this.renderTimeZone()}
        {this.renderSample()}
        {this.renderSaveButton()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    timeZone: state[REDUCER_NAME].settingSystem.dataSystem.timeZone,
    timeFormat: state[REDUCER_NAME].settingSystem.dataSystem.timeFormat,
  };
};

const mapDispatchToProps = {
  changeTimeZone,
  callApiSystemSetting,
  updateUserSetting,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GeneralContentSetting);
